"use strict";

import angular from "angular";

angular.module("nucont.accounting.overview", ["nucont.shared"]);
require("./accounting-overview.routes");
require("./dashboard/accounting-overview-dashboard.routes");
require("./portfolio/accounting-overview-portfolio.routes");
require("./portfolio/companies/accounting-overview-portfolio-companies.routes");
require("./portfolio/groups/accounting-overview-portfolio-groups.routes");
